import axios from 'axios';
import { TypeLabel } from '../../../../commentary/commentary.types';

export type GetCommentaryResponse = {
  author: string;
  dateHtml: string;
  format: 'HTML' | 'PDF';
  sourceName: string;
  title: string;
  url: string;
} & (
  | { typeLabel: TypeLabel.HYBRID }
  | { typeLabel: TypeLabel.OPEN }
  | { typeLabel: TypeLabel.PAPER }
);

export function getCommentariesUrls(
  docId: string,
  query: string,
): Promise<{ data: Array<GetCommentaryResponse> }> {
  return axios.get('/get_comments_urls', {
    params: {
      docId,
      q: query,
    },
  });
}
